import React from 'react';
import { Icon } from '../../../components/ui/Icon';
import styles from './PanelToggle.module.css';

/**
 * PanelToggle — collapse/expand control for the workflow's side panels,
 * rendered into the subheader's row-2 ends via WorkspaceChromeContext. One
 * component drives both sides: `side="right"` mirrors the glyph so the left
 * (rail) and right (reviewer panel) toggles read as a matched pair.
 */
export default function PanelToggle({ side = 'left', collapsed = false, onToggle }) {
  const target = side === 'left' ? 'workflow rail' : 'reviewer panel';
  const label = `${collapsed ? 'Expand' : 'Collapse'} ${target}`;
  return (
    <button
      type="button"
      className={`${styles.toggle} ${side === 'right' ? styles.flip : ''}`}
      onClick={onToggle}
      title={label}
      aria-label={label}
      aria-pressed={collapsed}
    >
      <Icon name="sidebar-toggle" size={16} />
    </button>
  );
}
